import { FC, useMemo } from "react";

import { useFormatDate, useT } from "src/internationalization";
import { Case, CaseSummary } from "src/types/case";

import { CaseVersionsDiffTable } from "./CaseVersionsDiffTable";
import { VersionConfig } from "./CaseVersionsDiffTable.types";

export type CaseVersionsDiffModalProps = {
  currentCase: CaseSummary;
  creationCase: Case;
  onClose: () => void;
};

export const CaseVersionsDiffModal: FC<CaseVersionsDiffModalProps> = ({
  currentCase,
  creationCase,
  onClose,
}) => {
  const t = useT();
  const formatDate = useFormatDate();

  // Build versions array: creation -> current
  // The first version (creation) is the baseline, current is compared to it
  const versions: VersionConfig[] = useMemo(
    () => [
      {
        key: "creation",
        label: t("caseVersions.diff.table.scored", {
          date: formatDate(creationCase.snapshotCreation),
        }),
        date: creationCase.snapshotCreation ? new Date(creationCase.snapshotCreation) : null,
        case: creationCase,
      },
      {
        key: "current",
        label: t("caseVersions.diff.table.current", {
          date: formatDate(new Date()),
        }),
        date: null,
        case: currentCase,
      },
    ],
    [creationCase, currentCase, formatDate, t]
  );

  return (
    <CaseVersionsDiffTable
      versions={versions}
      title={t("caseVersions.diff.modal.title")}
      subtitle={`${creationCase.configurableType.name} ${creationCase.request}`}
      onClose={onClose}
      searchInputId="searchCaseDiffs"
      tableId="caseVersionsDiff"
    />
  );
};
